<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-file-group`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.418 12.597v28.448A1.96 1.96 0 0137.454 43H4.964A1.96 1.96 0 013 41.045V14.597a2 2 0 012-2h34.418zm-3.928 3.91H6.928V39.09H35.49V16.506zM44 6a2 2 0 012 2v23h-4l-.001-21H18V6h26zM20 21a1 1 0 011 1v2a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2a1 1 0 011-1h7z"/></svg>
</template>
<script>

export default {
  name: 'IconFileGroup',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
